export { default as MarketNavTextIcon } from './market_nav_text.svg';
